import { RouteType } from '@weave/schema-gen-ts/dist/schemas/phone/tree/v1/phone_tree_service.pb';
import { useTranslation } from '@frontend/i18n';
import { Text } from '@frontend/design-system';
import { RepeatInstruction } from '../types';
import { PhoneTreeInstructionField } from './phone-tree-instruction-field';
import { ReadOnlyInstructionField } from './read-only-instruction';

export type RepeatPayload = { subTreeId: string };

export const RepeatInstructionField = ({ instructionState }: { instructionState: RepeatInstruction }) => {
  const { t } = useTranslation('phone');

  // If the treeId is set, then this is a repeat of a phone tree different than the current one. For these cases,
  // we show the linked phone tree instruction field.
  const treeId = instructionState?.data?.treeId;

  return (
    <>
      <ReadOnlyInstructionField instructionName={t('Repeat Phone Tree')} iconName={'automated-message'} />

      {!!treeId && (
        <>
          <Text>{'>'}</Text>
          <PhoneTreeInstructionField
            instructionState={{
              id: treeId,
              name: instructionState.data.treeName ?? '',
              type: RouteType.ROUTE_TYPE_IVR_MENU,
            }}
          />
        </>
      )}
    </>
  );
};
